module.exports = __webpack_public_path__ + "static/media/Shop-Tires-Icon-White.a9932751.svg";